export default (value: string | undefined) => {
    return value === "True" || value === "true";
};
